import { inventoryByProductVersionFromFirestore } from '@parallel-fluidics/shared/models/inventory';
import { useQuery } from '@tanstack/react-query';
import {
  collection,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';

async function fetchInventoryByProductDocId(productDocId) {
  const q = query(
    collection(getFirestore(), 'inventoryByProductVersion'),
    where('productDocId', '==', productDocId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(inventoryByProductVersionFromFirestore);
}

export default function useInventoryByProductDocId(productDocId) {
  return useQuery({
    queryKey: ['inventoryByProductDocId', productDocId],
    queryFn: () => fetchInventoryByProductDocId(productDocId),
    enabled: !!productDocId,
    staleTime: 2 * 60 * 1000,
  });
}
